import { oauthSetupSteps } from "../oauthSetupSteps";
import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const kick = defineConnector({
  identifier: "kick",
  name: "Kick",
  tagLine: "Live streaming, channels, and chat",
  logo,
  tags: ["data"],
  protocol: "http",
  defaultUrlPattern: () => "https://api\\.kick\\.com/public/v1/.*",
  auth: oauthAuth,
  steps: oauthSetupSteps({
    identifier: "kick",
    registrationUrl: "https://kick.com/settings/developer",
    scopes: ["user:read"],
  }),
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () => "https://id.kick.com/oauth/authorize",
    tokenEndpoint: () => "https://id.kick.com/oauth/token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => ["user:read"],
    pkce: () => true,
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://api.kick.com/public/v1/users",
  },
});
